import * as contestActions from './actions';
import {ActionType, getType} from 'typesafe-actions';
import {ContestState, JsonContestItem, JsonStartListItem} from './types';
import DateUtils from "../../utils/Date.utils";
import Contest from "../../domain/Contest";
import Series from "../../domain/Series";
import SeriesItem from "../../domain/SeriesItem";
import {SeriesType} from "../../domain/SeriesType";
import StartList from "../../domain/StartList";
import StartListItem from "../../domain/StartListItem";

const defaultState: ContestState = {
  contest: undefined,
  lastUpdatedTimeStamp: DateUtils.getNowAsTimeStamp()
};

export default (state = defaultState, action: ActionType<typeof contestActions>): ContestState => {
  switch (action.type) {
    case getType(contestActions.removeContestDetail):
      return {
        ...state,
        contest: undefined,
        lastUpdatedTimeStamp: DateUtils.getNowAsTimeStamp()
      };
    case getType(contestActions.fetchContestItem.success):
      let seriesCounter = 0;
      const json = action.payload;
      return {
        ...state,
        contest: mapToContest(json, seriesCounter),
        lastUpdatedTimeStamp: DateUtils.getNowAsTimeStamp()
      };
    default:
      return state;
  }
}

function mapToContest(json: JsonContestItem, seriesCounter: number) {
  return new Contest(
    json.id,
    json.title,
    json.remarks,
    json.date,
    json.categories,
    json.address || "adres niet gekend",
    json.clubName,
    json.farrier || "niet gekend",
    json.veterinarian || "niet gekend",
    json.localResponsible || "niet gekend",
    json.firstAid || "niet gekend",
    json.mainJury || "niet gekend",
    json.location,
    new Series(json.series.map(s => {
      const hm: string[] = parseTime(s.start);
      return new SeriesItem(
        s.id,
        mapSeriesType(s.discipline),
        s.arena,
        s.level,
        parseInt(hm[0]),
        parseInt(hm[1]),
        mapStartList(s.startList)
      )
    }))
  );
}

function mapStartList(startList: JsonStartListItem[]) {
  return new StartList(
    startList.map(i => {
      const hm: string[] = parseTime(i.startTime);
      return new StartListItem(
        i.startNumber,
        i.headNumber,
        parseInt(hm[0]),
        parseInt(hm[1]),
        i.rider,
        i.horse,
        i.club
      )
    })
  )
}

function mapSeriesType(type: string): SeriesType {
  switch (type) {
    case "SPRINGEN":
      return "jumping";
    case "INDIVIDUELE DRESSUUR":
      return "dressage";
    case "VIERTALLEN DRESSUUR":
    case "ACHTTALLEN DRESSUUR":
      return "group-dressage";
    case "UITZONDERLIJKE PROEF":
      return "exceptional";
    default:
      let message = type + " not yet supported";
      console.error(message);
      return "dressage"
  }
}

function parseTime(time: string): Array<string> {
  if (time && time.indexOf(":") !== -1) {
    const parts = time.split(":");
    return [parts[0], parts[1]];
  }
  return ["", ""]
}



